import React, { useEffect } from "react";
import ProgressView from "./view";
import { noop } from "@client/shared/constants";
let timer = null;
const ProgressPanel = ({ handleSubmit = noop }) => {
  const [progress, setProgress] = React.useState(0);

  React.useEffect(() => {
    timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress >= 100) {
          clearInterval(timer);
          return 100;
        }
        const diff = Math.random() * 20;
        return Math.min(oldProgress + diff, 100);
      });
    }, 300);
    return () => {
      clearInterval(timer);
    };
  }, []);
  useEffect(() => {
    if (progress >= 100) {
      handleSubmit(true);
    }
  }, [progress]);
  return <ProgressView progress={progress} />;
};

export default ProgressPanel;
